__turbopack_context__.v({
  "body": "V1eYBG_body",
  "close": "V1eYBG_close",
  "content": "V1eYBG_content",
  "header": "V1eYBG_header",
});
